import Axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";
import { Language, APIError } from "src/types";

/**
 * Deserialize the json format into a Javascript object
 * @param data
 */
function deserialize(data: string): string {
  return data;
}

export function useLanguages() {
  async function queryFn(): Promise<Language[]> {
    const result = await Axios.get(`/planning-api/languages`);
    return result.data.map(deserialize);
  }

  return useQuery<Language[], AxiosError<APIError>>(baseDataKeys.languages, queryFn);
}
